module.exports = __webpack_public_path__ + "static/media/koombana-physiotherapy.9e583415.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/ContactUs/koombana-physiotherapy.png
// module id = 53
// module chunks = 0